if (!customElements.get('banner-slider')) {
  customElements.define(
    'banner-slider',
    class BannerSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.banner__slides');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.banner__dot'));
        if (this.slides.length < 2) return;

        this.current = 0;
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.current = this.slides.indexOf(entry.target);
              this.syncDots();
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        const delay = parseInt(this.dataset.autoplay, 10) || 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (delay > 0 && !reducedMotion) {
          this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), delay);
          ['pointerdown', 'wheel'].forEach((evt) =>
            this.track.addEventListener(evt, () => this.stopAutoplay(), { passive: true, once: true })
          );
          this.onVisibility = () => {
            if (document.hidden) this.stopAutoplay();
          };
          document.addEventListener('visibilitychange', this.onVisibility);
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      goTo(index) {
        this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
      }

      syncDots() {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.current);
          dot.setAttribute('aria-current', i === this.current ? 'true' : 'false');
        });
      }
    }
  );
}
